// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3780A","rightAdornment":"Header_rightAdornment__3PMHY"};